import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

import type { StagingReviewSummaryData } from './stagingApi';

interface StagingReviewSummaryProps {
  summary: StagingReviewSummaryData;
}

const StagingReviewSummary = ({ summary }: StagingReviewSummaryProps) => {
  const { totalRows, validCount, warningCount, errorCount } = summary;
  const hasErrors = errorCount > 0;

  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity={hasErrors ? 'error' : warningCount > 0 ? 'warning' : 'success'} sx={{ mb: 1.5 }}>
        <Typography variant="body2">
          {hasErrors ?
            `${errorCount} row(s) have errors that must be fixed before this adjustment can be applied.` :
            warningCount > 0 ?
              `All rows are valid, but ${warningCount} row(s) have warnings you may want to review.` :
              'All rows are valid and ready to apply.'}
        </Typography>
      </Alert>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        <Chip label={`${totalRows} total`} size="small" variant="outlined" />
        <Chip label={`${validCount} valid`} size="small" color="success" variant="outlined" />
        {warningCount > 0 && (
          <Chip label={`${warningCount} warnings`} size="small" color="warning" variant="outlined" />
        )}
        {errorCount > 0 && (
          <Chip label={`${errorCount} errors`} size="small" color="error" variant="outlined" />
        )}
      </Box>
    </Box>
  );
};

export default StagingReviewSummary;
